var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetailPageLoadingDesktop = function SvgDetailPageLoadingDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 276,
    fill: "none",
    viewBox: "0 0 400 276"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    fill: "#1A1A1A",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 24,
    y: 48,
    fill: "#1A1A1A",
    rx: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 20,
    y: 96,
    fill: "#1A1A1A",
    rx: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 12,
    y: 128,
    fill: "#1A1A1A",
    rx: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 12,
    y: 166,
    fill: "#1A1A1A",
    rx: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 12,
    y: 190,
    fill: "#1A1A1A",
    rx: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 48,
    y: 228,
    fill: "#1A1A1A",
    rx: 6
  })));
};
export default SvgDetailPageLoadingDesktop;